import { LEVEL_LABELS } from "@/lib/api";

/** Status → chip class + label */
export function statusChip(status) {
    const map = {
        intake: ["chip-muted", "Drafting"],
        drafted: ["chip-action", "Review draft"],
        ready_to_send: ["chip-action", "Send from your email"],
        awaiting_send: ["chip-action", "Send from your email"],
        sent_verified: ["chip-progress", "Sent"],
        sent_unverified: ["chip-waiting", "Sent — proof pending"],
        awaiting_reply: ["chip-progress", "Awaiting reply"],
        awaiting_window: ["chip-waiting", "Awaiting SLA"],
        escalation_due: ["chip-action", "Escalate"],
        regulator_eligible: ["chip-regulator", "RBI Ombudsman ready"],
        regulator_filed: ["chip-regulator", "Filed with RBI"],
        resolved: ["chip-resolved", "Resolved"],
        closed: ["chip-muted", "Closed"],
        dormant: ["chip-muted", "Dormant"],
    };
    const [cls, label] = map[status] || ["chip-muted", status];
    return <span className={`chip ${cls}`}>{label}</span>;
}

export function levelLabel(level) {
    return LEVEL_LABELS[level] || `Level ${level}`;
}
